import { SocialMediaPlatform, SocialMediaVideo } from './social-media.model'

const mediaPath = `${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/home/social-media`

// id do vídeo no YouTube, título e thumbnail — na mesma ordem dos links originais.
const youtubeContent = [
  { id: 'VvMvW4MuF7Y', title: 'Documentação para empréstimo', thumbnail: 'marina-documentacao-emprestimo-thumb.jpg' },
  { id: 'arByOxTfrmM', title: 'Taxa pré e pós-fixada', thumbnail: 'magally-taxa-pre-pos-fixada-thumb.jpg' },
  {
    id: 'mald15x_1OA',
    title: 'Reformas e melhorias no condomínio',
    thumbnail: 'leticia-reformas-melhorias-condominio-thumb.jpg'
  },
  { id: 'VcTDL5E6FKc', title: 'Financiamento da construção', thumbnail: 'joao-financiamento-construcao-thumb.jpg' },
  { id: 'hHwmTY-ZH3s', title: 'Como calcular os juros de um empréstimo', thumbnail: 'fran-calcular-juros-emprestimo-thumb.jpg' },
  { id: '9I2qLJld_Eg', title: 'Amortizar no prazo ou na prestação', thumbnail: 'daniele-amortizar-prazo-prestacao-thumb.jpg' }
]

const instagramContent = [
  { file: 'fabio-costa-como-estruturar-capital', title: 'Como estruturar capital' },
  { file: 'fabio-capital-inteligente', title: 'Capital inteligente não é sobre pegar crédito' },
  { file: 'fran-organizacao-financeira', title: 'Organização financeira' },
  { file: 'magally-mitos-verdades-financiamento', title: '3 mitos e 3 verdades sobre o financiamento' },
  { file: 'marina-imovel-vantagem-competitiva', title: 'Transformando imóvel em vantagem competitiva' },
  { file: 'nancy-capital-estruturado', title: 'Empresas que usam capital estruturado crescem mais rápido' }
]

const tiktokContent = [
  {
    file: 'ba-empresario-credito-inteligente',
    title: 'Crédito inteligente para o empresário',
    thumbnail: 'ba-empresario-credito-inteligente.png'
  },
  {
    file: 'fatima-quem-pode-solicitar-emprestimo',
    title: 'Quem pode solicitar empréstimo',
    thumbnail: 'fatima-quem-pode-solicitar-emprestimo.jpg'
  },
  { file: 'fran-e-ba-gol-ou-gol-contra', title: 'Gol ou gol contra', thumbnail: 'fran-e-ba-gol-ou-gol-contra.png' },
  {
    file: 'leticia-credito-realizar-sonho',
    title: 'Crédito para realizar o sonho',
    thumbnail: 'leticia-credito-realizar-sonho.jpg'
  },
  {
    file: 'leticia-obra-estalar-de-dedos',
    title: 'Obra num estalar de dedos',
    thumbnail: 'leticia-obra-estalar-de-dedos.jpg'
  }
]

const linkedinContent = [
  { file: 'cashme-day', title: 'CashMe Day', thumbnail: 'cashme-day-2025.jpg' },
  { file: 'cashme-in', title: 'CashMe In', thumbnail: 'cashme-in.jpg' },
  { file: 'cashme-morumbis', title: 'CashMe Morumbis', thumbnail: 'cashme-morumbis.jpg' },
  { file: 'cashme-torcida-azul', title: 'CashMe Torcida Azul', thumbnail: 'cashme-torcida-azul.jpg' },
]

const youtubeVideos: SocialMediaVideo[] = youtubeContent.map(({ id, title, thumbnail }) => ({
  type: 'embed',
  videoUrl: `https://www.youtube-nocookie.com/embed/${id}?autoplay=1`,
  videoTitle: title,
  thumbnail: `${mediaPath}/youtube/${thumbnail}`,
  alt: `Capa do vídeo: ${title}`
}))

const instagramVideos: SocialMediaVideo[] = instagramContent.map(({ file, title }) => ({
  type: 'video',
  videoUrl: `${mediaPath}/instagram/${file}.mp4`,
  videoTitle: title,
  thumbnail: `${mediaPath}/instagram/${file}.jpg`,
  alt: `Capa do reel: ${title}`
}))

const tiktokVideos: SocialMediaVideo[] = tiktokContent.map(({ file, title, thumbnail }) => ({
  type: 'video',
  videoUrl: `${mediaPath}/tiktok/${file}.mp4`,
  videoTitle: title,
  thumbnail: `${mediaPath}/tiktok/${thumbnail}`,
  alt: `Capa do vídeo: ${title}`
}))

const linkedinVideos: SocialMediaVideo[] = linkedinContent.map(({ file, title, thumbnail }) => ({
  type: 'video',
  videoUrl: `${mediaPath}/linkedin/${file}.mp4`,
  videoTitle: title,
  thumbnail: `${mediaPath}/linkedin/${thumbnail}`,
  alt: `Capa do vídeo: ${title}`
}))

// A ordem aqui define a ordem dos botões e qual plataforma inicia ativa (índice 0).
export const socialMediaPlatforms: SocialMediaPlatform[] = [
  {
    platform: 'youtube',
    label: 'YouTube',
    videos: youtubeVideos
  },
  {
    platform: 'instagram',
    label: 'Instagram',
    videos: instagramVideos
  },
  {
    platform: 'tiktok',
    label: 'TikTok',
    videos: tiktokVideos
  },
  {
    platform: 'linkedin',
    label: 'LinkedIn',
    videos: linkedinVideos
  }
]
